export default __webpack_public_path__ + "static/usa-map-b7111671ec0b7c3cff0b3d1c33e14a9f.png";